"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(_ref) {
  var config = _ref.config,
      valueSources = _ref.valueSources,
      valueSrc = _ref.valueSrc,
      title = _ref.title,
      setValueSrc = _ref.setValueSrc,
      readonly = _ref.readonly;
  // const renderOptions = (valueSources) => (
  //   valueSources.map(([srcKey, info]) => (
  //     <option key={srcKey} value={srcKey}>{info.label}</option>
  //   ))
  // );
  var options = (0, _react.useMemo)(function () {
    return valueSources.map(function (_ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
          srcKey = _ref3[0],
          info = _ref3[1];

      return (// <option key={srcKey} value={srcKey}>{info.label}</option>
        {
          key: srcKey,
          label: info.label
        }
      );
    });
  }, [valueSources]);

  var onChange = function onChange(e) {
    return setValueSrc(e[0] ? e[0].key : "");
  };

  var selectedValue = (0, _react.useMemo)(function () {
    if (valueSrc) {
      return [options.find(function (item) {
        return item.key === valueSrc;
      })];
    }
  }, [valueSrc, options]);
  return /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Form.Select, {
    id: "select-vsrc-typeahead",
    selected: selectedValue,
    onChange: onChange,
    disabled: readonly,
    options: options,
    size: "sm",
    placeholder: "Select",
    labelKey: "label"
  }); // return (
  //   <select
  //     onChange={onChange}
  //     value={valueSrc}
  //     disabled={readonly}
  //   >
  //     {renderOptions(valueSources)}
  //   </select>
  // );
};

exports["default"] = _default;